import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from "moment";
import { Col, Form, Input, Modal, Row } from "antd";
import { EditDocumentIcon } from "../../../resource/icons";

import actions from '../store/actions/edit-document.actions';

const { TextArea } = Input;

const EditTopicModal = ({
	docType,
	visible,
	onCancel,
	fprops,
	getFieldDecorator,
  validateFields,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();

	const subject = "Произвльная тема документа";
	const subject_err = "произвольную тему документа";

  const onOk = useCallback(() => {
    validateFields((err, values) => {
      if (err) return;
      const v = prepareDataAndResetFields(values);
      dispatch(actions.updateDocTopic(v.id, v.Topic, docType));
      dispatch(actions.closeModal());
    });
  }, [dispatch, docType, prepareDataAndResetFields, validateFields]);

	return (
		<Modal
			style={{ minWidth: 550 }}
			width={550}
			visible={visible}
			title={
				<span>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					{subject}
				</span>
			}
			okText="Изменить"
			onCancel={onCancel}
			onOk={onOk}
		>
			<Form layout="vertical">
				{getFieldDecorator("OrgId", {
					initialValue: fprops.org && fprops.org.id,
				})(<div />)}
				{getFieldDecorator("executerId", {
					initialValue: fprops.appointedWorker && fprops.appointedWorker.id,
				})(<div />)}
				{getFieldDecorator("DocNumber", {
					initialValue: fprops.docNumber,
				})(<div />)}
				{getFieldDecorator("DocMoment", {
					initialValue: fprops.docDate ? moment(fprops.docDate) : moment(),
				})(<div />)}
				<Row gutter={8}>
					<Col span={24}>
						<Form.Item label={subject}>
							{getFieldDecorator("Topic", {
								initialValue: fprops.topic,
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите " + subject_err,
									},
								],
							})(<TextArea autoSize={{ maxRows: 3 }} />)}
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default EditTopicModal;
